// ============================================================================
// MILLER-RABIN - ALGORITHM METADATA
// ============================================================================

export const meta = {
  id: 'miller-rabin',
  name: 'Miller-Rabin Primality Test',
  category: 'Math',
  complexity: {
    time: 'O(k log³ N)',
    space: 'O(1)'
  },
  description: 'A probabilistic primality test that determines whether a given number is likely prime. Uses modular exponentiation and tests multiple random bases to achieve high accuracy with adjustable error probability.'
};
